import TaskIcon from '../../../assets/icons/task-icon.tsx';
import { DropdownMenuItem } from '../../../components/ui/dropdown-menu.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';
import type { TaskCreatedSource } from '../../analytics/types/analytics-events.ts';
import { useShowCreateTaskDialog } from '../hooks/use-show-create-task-dialog.ts';

export type TaskLinks = Pick<CrmTaskDTO['links'][0], 'modelId' | 'modelType' | 'title'>[];

type DropdownMenuItemCreateTaskProps = {
    links: TaskLinks;
    source: TaskCreatedSource;
};

export const DropdownMenuItemCreateTask = ({ links, source }: DropdownMenuItemCreateTaskProps) => {
    const { t } = useLocale();
    const showCreateTaskDialog = useShowCreateTaskDialog();

    return (
        <DropdownMenuItem
            onSelect={() => {
                showCreateTaskDialog({ links, source });
            }}
        >
            <TaskIcon className="h-4 w-4" />
            <span>{t('customer_detail__header__task', { ns: 'customer-detail' })}</span>
        </DropdownMenuItem>
    );
};
